import React, {useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import AddRoomTypeForm from "../AddRoomTypeForm";
import { updateRoomType } from "../../../store/send";
import { getRoomType } from "../../../store/actions";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const UpdateRoomTypeModal = ({
  open,
  handleClose,
  roomTypeId,
  roomtypeCard,
  getRoomType,
  updateRoomType,
  isUpdatingRoomType,
  updatedRoomType,
  classes,
  history,
}) => {
  const [formData, updateFormData] = React.useState(null);
  const [card, setCard] = React.useState(null);

  useEffect(() => {
    if (roomTypeId !== -1) {
      setCard(null);
      getRoomType(roomTypeId);
    }
  }, [roomTypeId]);

  useEffect(() => {
    setCard(roomtypeCard);
  }, [roomtypeCard]);

  const onConfirm = () => {
    if (roomTypeId && roomTypeId !== -1){
      updateRoomType(roomTypeId,formData);
    }
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (updatedRoomType && updatedRoomType.success) {
      handleClose();
    }
  }, [updatedRoomType]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Обновить тип помещения</DialogTitle>
        <DialogContent>
          {card &&
          <AddRoomTypeForm
            onFormChange={updateFormData}
            disabled={isUpdatingRoomType}
            initialData={card}
          />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isUpdatingRoomType}
            disabled={isUpdatingRoomType}
            onClick={() => onConfirm()}
            color="green"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  isUpdatingRoomType: state.nomenclature.isUpdatingRoomType,
  updatedRoomType: state.nomenclature.updatedRoomType,
  roomtypeCard: state.nomenclature.roomtypeCard
});

const mapDispatchToProps = dispatch => ({
  updateRoomType: (id,data) => dispatch(updateRoomType(id,data)),
  getRoomType: (id) => dispatch(getRoomType(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UpdateRoomTypeModal)));
